import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { installFetchProgress } from './lib/progress';
import { installEta } from './lib/eta';
import { installBasePath, basePath } from './lib/basepath';

// Base-path first: it patches window.fetch to prefix /api/ under a sub-path,
// so the progress/eta fetch wrappers below see the already-prefixed URL.
installBasePath();
installFetchProgress();
installEta();

// React Router basename: undefined at root, "/bi" (no trailing slash) when the
// SPA is served under /bi/ behind the proxy (window.__base__ injected by the Go server).
const basename = basePath() === '/' ? undefined : basePath().replace(/\/$/, '');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
